$wj([25],{

/***/ 1880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sendAutomatedMessage_1 = __webpack_require__(3986);
exports.sendAutomatedMessage = sendAutomatedMessage_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 3128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function fileAttachment(data) {
    var result = tslib_1.__assign({ __type: 'FileAttachment:#Exchange' }, data);
    return result;
}
exports.default = fileAttachment;


/***/ }),

/***/ 3213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function createAttachmentJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'CreateAttachmentJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = createAttachmentJsonRequest;


/***/ }),

/***/ 3214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function createAttachmentRequest(data) {
    var result = tslib_1.__assign({ __type: 'CreateAttachmentRequest:#Exchange' }, data);
    return result;
}
exports.default = createAttachmentRequest;


/***/ }),

/***/ 3986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var createAttachment_1 = __webpack_require__(3987);
var createDraft_1 = __webpack_require__(3988);
var sendMessage_1 = __webpack_require__(3989);
var updateAndSendMessage_1 = __webpack_require__(3990);
var constructMessageFromDetails_1 = __webpack_require__(3991);
var updateMessageId_1 = __webpack_require__(3992);
function sendAutomatedMessage(messageDetails, timeFormat) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var attachments, message, createDraftResponse, i;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attachments = messageDetails.attachments;
                    message = constructMessageFromDetails_1.default(messageDetails);
                    if (!!attachments) return [3 /*break*/, 1];
                    return [2 /*return*/, sendMessage_1.default(message, timeFormat)];
                case 1: return [4 /*yield*/, createDraft_1.default(message, timeFormat)];
                case 2:
                    createDraftResponse = _a.sent();
                    updateMessageId_1.default(message, createDraftResponse);
                    i = 0;
                    _a.label = 3;
                case 3:
                    if (!(i < attachments.length)) return [3 /*break*/, 6];
                    return [4 /*yield*/, createAttachment_1.default(attachments[i].content, attachments[i].name, message.ItemId)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    i++;
                    return [3 /*break*/, 3];
                case 6: return [2 /*return*/, updateAndSendMessage_1.default(message)];
            }
        });
    });
}
exports.default = sendAutomatedMessage;
//# sourceMappingURL=sendAutomatedMessage.js.map

/***/ }),

/***/ 3987:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var canary_1 = __webpack_require__(213);
var fileAttachment_1 = __webpack_require__(3128);
var createAttachmentJsonRequest_1 = __webpack_require__(3213);
var createAttachmentRequest_1 = __webpack_require__(3214);
var ServiceRequestUtils_1 = __webpack_require__(31);
var CREATE_ATTACHMENT_URL = '/owa/service.svc/CreateAttachmentFromLocalFile';
function createAttachment(file, fileName, parentItemId) {
    var attachment = fileAttachment_1.default({
        Name: fileName,
        Size: file.size,
        ContentType: file.type,
        IsInline: false,
        Content: '',
    });
    var attachmentTempId = fileName + '-' + new Date().toString();
    var requestBody = createAttachmentRequest_1.default({
        ParentItemId: parentItemId,
        Attachments: [attachment],
        RequireImageType: attachment.IsInline,
        IncludeContentIdInResponse: attachment.IsInline,
        ClientSupportsIrm: false,
        CancellationId: attachmentTempId,
    });
    var jsonRequest = createAttachmentJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    });
    var serializedRequest = JSON.stringify(jsonRequest);
    return fetch(CREATE_ATTACHMENT_URL, {
        method: 'POST',
        headers: {
            'X-OWA-Action': 'CreateAttachmentFromLocalFile',
            'X-OWA-CANARY': canary_1.getOwaCanaryCookie(),
            'X-OWA-UrlPostData': encodeURIComponent(serializedRequest),
        },
        body: file,
        credentials: 'include',
    }).then(function (response) {
        return response.json();
    });
}
exports.default = createAttachment;
//# sourceMappingURL=createAttachment.js.map

/***/ }),

/***/ 3988:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createItemOperation_1 = __webpack_require__(699);
var createItemRequest_1 = __webpack_require__(706);
var ServiceRequestUtils_1 = __webpack_require__(31);
var itemResponseShape_1 = __webpack_require__(149);
function createDraft(message, timeFormat) {
    var request = createItemRequest_1.default({
        ClientSupportsIrm: false,
        ComposeOperation: 'newMail',
        MessageDisposition: 'SaveOnly',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        Items: [message],
        UnpromotedInlineImageCount: 0,
        TimeFormat: timeFormat,
        ItemShape: itemResponseShape_1.default({
            BaseShape: 'IdOnly',
            ClientSupportsIrm: false,
            FilterHtmlContent: false,
            BodyType: 'HTML',
        }),
        ShapeName: 'MailCompose',
    });
    return createItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: request,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = createDraft;
//# sourceMappingURL=createDraft.js.map

/***/ }),

/***/ 3989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var createItemOperation_1 = __webpack_require__(699);
var createItemRequest_1 = __webpack_require__(706);
var ServiceRequestUtils_1 = __webpack_require__(31);
function sendMessage(message, timeFormat) {
    var request = createItemRequest_1.default({
        ClientSupportsIrm: false,
        ComposeOperation: 'newMail',
        MessageDisposition: 'SendAndSaveCopy',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        Items: [message],
        UnpromotedInlineImageCount: 0,
        TimeFormat: timeFormat,
    });
    return createItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: request,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = sendMessage;
//# sourceMappingURL=sendMessage.js.map

/***/ }),

/***/ 3990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateItemRequest_1 = __webpack_require__(635);
var ServiceRequestUtils_1 = __webpack_require__(31);
var updateItemOperation_1 = __webpack_require__(636);
var itemId_1 = __webpack_require__(94);
var itemChange_1 = __webpack_require__(637);
function createRequestBody(messageType) {
    var itemChanges = itemChange_1.default({
        Updates: [],
        ItemId: itemId_1.default({
            Id: messageType.ItemId.Id,
            ChangeKey: messageType.ItemId.ChangeKey,
        }),
    });
    return updateItemRequest_1.default({
        ItemChanges: [itemChanges],
        ConflictResolution: 'AlwaysOverwrite',
        ClientSupportsIrm: false,
        SendCalendarInvitationsOrCancellations: 'SendToNone',
        MessageDisposition: 'SendAndSaveCopy',
        SuppressReadReceipts: false,
        ComposeOperation: 'newMail',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        UnpromotedInlineImageCount: 0,
        PromoteInlineAttachments: false,
        SendOnNotFoundError: true,
    });
}
function updateAndSendMessage(message) {
    var requestBody = createRequestBody(message);
    return updateItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = updateAndSendMessage;
//# sourceMappingURL=updateAndSendMessage.js.map

/***/ }),

/***/ 3991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var message_1 = __webpack_require__(373);
var bodyContentType_1 = __webpack_require__(679);
var getUserConfiguration_1 = __webpack_require__(9);
function constructMessageFromDetails(messageDetails) {
    var subject = messageDetails.subject, message = messageDetails.message, to = messageDetails.to;
    return message_1.default({
        Body: bodyContentType_1.default({ BodyType: 'HTML', Value: message }),
        Subject: subject,
        ToRecipients: to.map(function (alias) { return ({
            EmailAddress: alias,
        }); }),
        CcRecipients: [
            {
                EmailAddress: getUserConfiguration_1.default().SessionSettings.UserEmailAddress,
            },
        ],
        BccRecipients: [],
    });
}
exports.default = constructMessageFromDetails;
//# sourceMappingURL=constructMessageFromDetails.js.map

/***/ }),

/***/ 3992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var itemId_1 = __webpack_require__(94);
function updateMessageId(automatedMessage, response) {
    var responseMessage = response.ResponseMessages.Items[0];
    var message = responseMessage.Items[0];
    if (message) {
        automatedMessage.ItemId = itemId_1.default({ Id: message.ItemId.Id });
    }
}
exports.default = updateMessageId;
//# sourceMappingURL=updateMessageId.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.AutomatedMessage.js